export const IS_ALPHIN_FE_URL = /(?:https?:\/\/)?(?:app\.)?(?:alphin\.)(?:dev|io)(?:\.[a-z]{2,3})?/;

export const ONESIGNAL_HIDE_BANNER_TIMEOUT = 'onesignalHideBannerTimeout';
